import ApiCollection                from '@widesk-core/models/ApiCollection';
import CodeModel                    from '@/models/services/code/CodeModel';
import CodePropertyValueModel       from '@/models/services/code/CodePropertyValueModel';
import TicketPageBox                from './TicketPageBox';
import FondationsEntertainmentModel from '@/models/services/fondations/EntertainmentModel';
import CodeTypePropertyValueModel   from '@/models/services/code/CodeTypePropertyValueModel';

interface ITicketPageContentProps {
	code: CodeModel;
	codePropertyValueCollection: ApiCollection<CodePropertyValueModel>;
	codeTypePropertyValueCollection: ApiCollection<CodeTypePropertyValueModel>;
	gespassEntertainment: FondationsEntertainmentModel | undefined;
}

const TicketPageContent = (props: ITicketPageContentProps) => {

	const { code, codePropertyValueCollection, codeTypePropertyValueCollection, gespassEntertainment }  = props;

	return (
		<TicketPageBox code={code} codePropertyValueCollection={codePropertyValueCollection} codeTypePropertyValueCollection={codeTypePropertyValueCollection} gespassEntertainment={gespassEntertainment} />
	)
}

export default TicketPageContent;